import Vue from 'vue'
import LocaleSelector from '~/components/common/LocaleSelector'
import $moment from 'moment'

if (!window.onEvent) {
  window.onEvent = {}
}

if (!window._templateComponents) {
  window._templateComponents = {}
}

// 각 템플릿 별 API URL
window._apiUrls = {
  'seller-item': '/user/public/seller',
  'my-attended-lectures-item': '/atnlc/myAttendedLectures',
  'subscribed-channels-item': '/channel/subscribedChannels',
  'my-play-hist-item': '/atnlc/myPlayHist',
  'my-purchases-item': '/goods/myPurchases',
  'my-uploaded-item': '/goods/myUploaded',
  'order-item': '/order/public/orders',
  'banner-control': '/banner/public/banner',
  'bbsctt-item-detail': '/bbs/public/bbsctt',
  'update-item-control': '/bbs/public/bbsctt',
  'order-display': '/order/public/order',
  'goods-display': '/goods/public/goodsDetail',
  'channel-display': '/channel/public/channelDetail',
  'player-control': '/goods/public/goodsDetail',
  'bbsctt-item': '/bbs/public/bbsctts',
  'bbsctt-comment-item': '/bbs/public/bbscttComments',
  'media-chnnel-item': '/media/public/media',
  'media-chnnel-all-item': '/media/public/mediaChannel',
  'mediachnnel-item-detail': '/media/public/mediaChannelDetail',
  'media-item': '/media/public/mediaVideoByChannel',
  'media-search-item': '/media/public/mediaSearchAll',
  'media-item-detail': '/media/public/mediaDetail',
  'study-detail': '/channel/studyChannels',
  'study-lecture-control': '/channel/studyChannels',
  'media-rela-item': '/media/public/mediaById',
  'recommend-link-control': '/recomend-link/public/recomend-link',
  'faq-category-control': '/faq/getFaqInfos',
  'offline-meeting-control': '/offline_meeting/getCategories'
}
window.Vue = Vue
window.$moment = $moment
Vue.prototype.window = window
Vue.prototype.$moment = $moment
Vue.mixin({
  comments: true,
  components: {
    LocaleSelector
  },
  data: function() {
    return {
      partsHtml: {},
      partsLoadingStatus: {},
      templates: [],
      htmlDrawn: {},
      waitingTemplates: [],
      vueOnHtmlLoaded: false
    }
  },
  watch: {
    $route(to, from) {
      if (window.onEvent['route-changed']) {
        window.onEvent['route-changed'](to, from)
      }
    },
    '$route.hash': {
      handler(newVal, oldVal) {
        this.resetPageInfos()
        if (this.hashPart) {
          this.loadHashPart(newVal)
        }
      }
    },
    '$route.query.id': {
      handler(newVal, oldVal) {
        this.resetPageInfos()
        if (this.hashPart) {
          this.loadHashPart(this.$route.hash)
        }
      }
    }
  },
  mounted() {
    if (!$(this.$el).attr('component-id')) {
      if (!window._componentId) {
        window._componentId = 0
      }
      window._componentId++
      $(this.$el).attr('component-id', window._componentId)
      this.componentId = window._componentId
    }
    if (this.vueOnHtml) {
      this.$eventHub.$emit('vueOnHtmlLoaded')
    } else {
      this.$eventHub.$on('vueOnHtmlLoaded', this.onVueOnHtmlLoaded)
    }
    this.$eventHub.$on('redraw', this.redraw)
    this.isThemeComponent = false
    if (this.hasAttribute('theme') || this.hasAttribute('theme-bbs')) {
      this.$eventHub.$on('search-items', this.onSearchItems)
      this.$eventHub.$on('items-page-clicked', this.onItemsPageClicked)
      this.$eventHub.$on('more-items-clicked', this.onMoreItemsClicked)
      this.$eventHub.$on('mode-changed', this.onModeChanged)
      this.$eventHub.$on('items-loaded', this.onItemsLoaded)
      this.$eventHub.$on('show-item-detail', this.onShowItemDetail)
      this.$eventHub.$on('update-item', this.onUpdateItem)
      this.$eventHub.$on('create-item-form', this.onCreateItemForm)
      this.$eventHub.$on('show-item-list', this.onShowItemList)
      this.$eventHub.$on('show-me-items-page-info', this.onShowMeItemsPageInfo)
      this.isThemeComponent = true
      const self = this
      this.$watch('configs', function(newVal, oldVal) {
        self.$forceUpdate()
        if (!self.theme) {
          self.theme = self.configs.theme
          if (self.hasAttribute('theme')) {
            self.loadThemeScripts(() => {
              self.loadHtml()
            })
          }
        }
      })
      if (this.configs) {
        this.theme = this.configs.theme
        if (this.hasAttribute('theme')) {
          self.loadThemeScripts(() => {
            self.loadHtml()
          })
        }
      }
      this.pageInfos = []
      this.pageNumbers = []
      this.searchParams = []
    }

    let hash
    if (this.$route) {
      hash = this.$route.hash
    }
    if (this.hashPart && hash) {
      for (let i = 0; i < this.parts.length; i++) {
        if (this.parts[i].elem === this.hashPart) {
          this.parts[i].originalHtmlFile = this.parts[i].htmlFile
          this.parts[i].htmlFile = hash.substring(1)
          break
        }
      }
    }
  },
  beforeDestroy() {
    if (this.loadedParts) {
      for (const part in this.loadedParts) {
        this.removePartTemplates(part)
      }
    }
    if (!this.vueOnHtml) {
      this.$eventHub.$off('vueOnHtmlLoaded', this.onVueOnHtmlLoaded)
    }
    if (this.isThemeComponent) {
      this.$eventHub.$off('search-items', this.onSearchItems)
      this.$eventHub.$off('items-page-clicked', this.onItemsPageClicked)
      this.$eventHub.$off('more-items-clicked', this.onMoreItemsClicked)
      this.$eventHub.$off('mode-changed', this.onModeChanged)
      this.$eventHub.$off('items-loaded', this.onItemsLoaded)
      this.$eventHub.$off('show-item-detail', this.onShowItemDetail)
      this.$eventHub.$off('update-item', this.onUpdateItem)
      this.$eventHub.$off('create-item-form', this.onCreateItemForm)
      this.$eventHub.$off('show-item-list', this.onShowItemList)
      this.$eventHub.$off('show-me-items-page-info', this.onShowMeItemsPageInfo)
    }
    this.$eventHub.$off('redraw', this.redraw)
  },
  methods: {
    onKeypressOnInput(e) {
      if (e.keyCode === 13) {
        if ($(e.target).attr('tabindex')) {
          const nextElement = $(
            '[tabindex=' + (parseInt($(e.target).attr('tabindex')) + 1) + ']'
          )
          setTimeout(() => {
            nextElement.focus()
            if (!nextElement.val()) {
              nextElement.val('')
            }
          }, 300)
        }
      }
    },
    getIntakeRate(reset) {
      if (!reset || !reset.intakeRate) {
        return 0
      }
      return reset.intakeRate
    },
    getEnv() {
      if (!process || !process.env || !process.env.env) {
        return 'production'
      }
      return process.env.env
    },
    escapeHtmlWithNewLine(str) {
      if (!str) {
        return str
      }
      str = str.escapeHtml()
      str = str.replace(/\n/g, '<br />')
      return str
    },
    resetPageInfos() {
      if (this.pageInfos) {
        for (const key in this.pageInfos) {
          if (this.pageInfos[key].lastId) {
            delete this.pageInfos[key].lastId
          }
          if (this.pageInfos[key].pageNo) {
            this.pageInfos[key].pageNo = 1
          }
        }
      }
      if (this.templates) {
        for (const key in this.templates) {
          if (this.templates[key].originalScrollTop) {
            this.templates[key].originalScrollTop = 0
          }
          $('html').scrollTop(0)
        }
      }
    },
    changeHash(hash) {
      if (!hash.startsWith('#')) {
        hash = '#' + hash
      }
      this.$router.push({
        path: this.$router.currentRoute.path,
        hash: hash
      })
    },
    loadHashPart(hash) {
      if (this.hashPartLoading) {
        return
      }
      if (!this.theme) {
        setTimeout(() => {
          this.loadHashPart(hash)
        }, 50)
      }
      this.hashPartLoading = true
      this.forceRedraw = true
      this.htmlDrawn[this.hashPart] = false
      this.setPartsLoadingStatus(this.hashPart, '')
      /* this.forceRedraw = true
          this.loadedHtml = undefined
          this.htmlDrawn['#media-content'] = false
          this.setPartsLoadingStatus('#media-content', '') */
      const baseUrl =
        location.protocol +
        '//' +
        location.host +
        '/themes/' +
        this.theme +
        '/pack/' +
        this.path
      let file
      if (hash) {
        file = hash.substring(1)
      } else {
        for (let i = 0; i < this.parts.length; i++) {
          if (this.parts[i].elem === this.hashPart) {
            file = this.parts[i].htmlFile
            break
          }
        }
      }
      let v = ''
      if (localStorage && localStorage.buildTime) {
        v = '?v=' + localStorage.buildTime
      }
      $.ajax(baseUrl + '/' + file + '.html' + v).done(
        (responseText, status, xhr) => {
          if (
            status === 'success' &&
            responseText.indexOf('<!-- html part') >= 0
          ) {
            this.drawPart(responseText, this.hashPart)
            this.setPartsLoadingStatus(this.hashPart, 'loaded')
          } else {
            $(this.$el)
              .find(this.hashPart)
              .load(baseUrl + 'error/404.html')
          }
          this.hashPartLoading = false
        }
      )
    },
    getMyMaxRole() {
      if (!this.loggedInUser) {
        return
      }
      if (
        !this.loggedInUser.siteRoles ||
        this.loggedInUser.siteRoles.length === 0
      ) {
        return
      }
      let role
      for (let i = 0; i < this.loggedInUser.siteRoles.length; i++) {
        const siteRole = this.loggedInUser.siteRoles[i]
        if (!siteRole || !siteRole.site || siteRole.site.id !== 'homepage') {
          continue
        }
        if (!role || siteRole.role.roleGrad < role.roleGrad) {
          role = siteRole.role
        }
      }
      return role
    },
    getDiffFromRoleGradeToMine(paramRole) {
      if (!this.loggedInUser) {
        return 1000000
      }
      if (
        !this.loggedInUser.siteRoles ||
        this.loggedInUser.siteRoles.length === 0
      ) {
        return 1000000
      }
      let diffRet = 1000000
      for (let i = 0; i < this.loggedInUser.siteRoles.length; i++) {
        const siteRole = this.loggedInUser.siteRoles[i]
        if (siteRole) {
          const site = siteRole.site
          if (site && site.id !== 'homepage') {
            continue
          }
        }
        const role = siteRole.role
        const diff = role.roleGrad - paramRole.roleGrad
        if (diff < diffRet) {
          diffRet = diff
        }
      }
      return diffRet
    },
    loadBbs() {
      if (!this.path) return
      if (this.isGroup && !this.$route.query.bbsId) return
      let menuAlias = this.$router.currentRoute.fullPath
      if (menuAlias.indexOf('?') >= 0) {
        menuAlias = menuAlias.substring(0, menuAlias.indexOf('?'))
      }
      let url = '/bbs/public/bbs?menu=' + encodeURIComponent(menuAlias)
      if (this.$route.query.bbsId) {
        url += '&bbsId=' + this.$route.query.bbsId
      }
      this.$axios
        .$get(url, {
          no_loading: true
        })
        .then(response => {
          if (response.resultCode === 'success') {
            this.bbs = response.data.bbs
            this.authors = response.data.authors
            this.bbsType = this.bbs.bbsTyCode.substring('bbs_type.'.length)
            if (!this.path.endsWith('/')) {
              this.path += '/'
            }
            this.path += this.bbsType
            // if (this.bbs.useCaptureFlag === 'Y') {
            //   if (window.device && window.device.enableCapture) {
            //     window.device.enableCapture()
            //   }
            // } else if (window.device && window.device.disableCapture) {
            //   window.device.disableCapture()
            // }
            this.loadHtml()
          }
        })
    },
    hasAttribute(attrName) {
      const attr = $(this.$el).attr(attrName)
      return typeof attr !== typeof undefined && attr !== false
    },
    getMainComponentId() {
      return parseInt(
        $(this.$el)
          .closest('[theme],[theme-main-layout],[theme-bbs],[theme-custom]')
          .attr('component-id')
      )
    },
    onItemsPageClicked(params) {
      if (this.isAcceptible(params)) {
        this.loadItems(params.pageNo, null, params.componentId, params.groupId)
      }
    },
    onModeChanged() {
      this.loadedLastIds = {}
    },
    onMoreItemsClicked(params) {
      if (this.isAcceptible(params)) {
        if (!this.loadedLastIds) {
          this.loadedLastIds = {}
        }
        if (this.loadedLastIds[params.lastId]) {
          return
        }
        this.loadedLastIds[params.lastId] = true
        this.loadItems(null, params.lastId, params.componentId, params.groupId)
      }
    },
    onShowMeItemsPageInfo(params) {
      if (this.isAcceptible(params)) {
        this.emitItemsPageInfo(params)
      }
    },
    emitItemsPageInfo(params) {
      if (!this.pageInfos[params.groupId]) {
        setTimeout(() => {
          this.emitItemsPageInfo(params)
        })
        return
      }
      this.$eventHub.$emit(
        'items-page-info-loaded',
        this.pageInfos[params.groupId]
      )
    },
    onItemsLoaded(pageInfo) {
      if (this.isAcceptible(pageInfo)) {
        this.pageInfos[pageInfo.groupId] = pageInfo
      }
    },
    onSearchItems(params) {
      console.log(params, this.isAcceptible(params), this.componentId)
      if (this.isAcceptible(params)) {
        this.searchParams[params.groupId] = params
        if (this.pageInfos[params.groupId]) {
          delete this.pageInfos[params.groupId].lastId
          delete this.pageInfos[params.groupId].pageNo
        }
        this.loadItems(params.pageNo, null, params.componentId, params.groupId)
      }
    },
    searchMediaItem(e, selector, url) {
      e.stopPropagation()
      e.preventDefault()
      const st = $(this.$el)
        .find(selector)
        .val()
      this.$router.push({
        path: '#/' + url,
        query: { q: st }
      })
    },
    onSearchItemsEnter(e, selector) {
      if (e && e.keyCode === 13) {
        this.searchItems(e, selector)
      }
    },
    searchItems(e, selector, componentId) {
      e.preventDefault()
      e.stopPropagation()
      if (!componentId) {
        componentId = this.getMainComponentId()
      }
      this.$eventHub.$emit('search-items', {
        componentId: componentId,
        searchText: $(this.$el)
          .find(selector)
          .val(),
        selector: selector,
        pageNo: 1,
        groupId: $(e.currentTarget)
          .closest('[group-id]')
          .attr('group-id')
      })
    },
    loadItems(pageNumber, lastId, componentId, groupId) {
      if (this.componentId !== componentId) {
        return
      }
      if (pageNumber) {
        this.pageNumbers[groupId] = pageNumber
      }
      for (let i = 0; i < this.templates.length; i++) {
        const template = this.templates[i]
        if (template.groupId !== groupId) {
          continue
        }
        let pageNo = this.pageNumbers[groupId]
        if (template.options && template.options.topFlag === 'Y') {
          pageNo = 1
        }
        if (template.name.endsWith('-item')) {
          this.loadTemplateData(
            template,
            'list',
            this.escapedTempHtml,
            {
              searchText: this.searchParams[groupId]
                ? this.searchParams[groupId].searchText
                : '',
              pageNo: pageNo,
              lastId: lastId
            },
            true,
            true
          )
        }
      }
    },
    createItemForm(e) {
      e.preventDefault()
      e.stopPropagation()
      this.$eventHub.$emit('create-item-form', {
        componentId: this.getMainComponentId(),
        groupId: $(e.currentTarget)
          .closest('[group-id]')
          .attr('group-id')
      })
    },
    showItemDetail(e, item) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
        this.vibrate(e)
      }
      this.$eventHub.$emit('show-item-detail', {
        componentId: this.getMainComponentId(),
        groupId: $(e.currentTarget)
          .closest('[group-id]')
          .attr('group-id'),
        item: item
      })
    },
    updateItem(e, item) {
      e.preventDefault()
      e.stopPropagation()
      this.$eventHub.$emit('update-item', {
        componentId: this.getMainComponentId(),
        groupId: $(e.currentTarget)
          .closest('[group-id]')
          .attr('group-id'),
        item: item
      })
    },
    deleteItem(e, item) {
      e.preventDefault()
      e.stopPropagation()
      this.$eventHub.$emit('delete-item-confirm', {
        componentId: this.getMainComponentId(),
        groupId: $(e.currentTarget)
          .closest('[group-id]')
          .attr('group-id'),
        item: item
      })
    },
    showItemList(e) {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }
      this.$eventHub.$emit('show-item-list', {
        componentId: this.getMainComponentId(),
        groupId: $(e.currentTarget)
          .closest('[group-id]')
          .attr('group-id')
      })
    },
    onShowItemDetail(params) {
      if (this.isAcceptible(params)) {
        const query = window.copyObject(this.$route.query)
        query.mode = 'detail'
        query.id = params.item.id
        this.$router.push({
          path: this.$router.currentRoute.path,
          query: query
        })
      }
    },
    onUpdateItem(params) {
      if (this.isAcceptible(params)) {
        const query = window.copyObject(this.$route.query)
        query.mode = 'update'
        query.id = params.item.id
        this.$router.push({
          path: this.$router.currentRoute.path,
          query: query
        })
      }
    },
    onCreateItemForm(params) {
      if (this.isAcceptible(params)) {
        const query = window.copyObject(this.$route.query)
        query.mode = 'create'
        this.$router.push({
          path: this.$router.currentRoute.path,
          query: query
        })
      }
    },
    onShowItemList(params) {
      if (this.isAcceptible(params)) {
        const query = window.copyObject(this.$route.query)
        query.mode = 'list'
        this.$router.push({
          path: this.$router.currentRoute.path,
          query: query
        })
      }
    },
    isAcceptible(params) {
      if (this.componentId === params.componentId) {
        return true
      }
      return false
    },
    loadHtml() {
      if (Object.keys(this.messages).length === 0) {
        setTimeout(() => {
          this.loadHtml()
        }, 50)
        return
      }
      if (!this.theme) {
        setTimeout(() => {
          this.loadHtml()
        }, 50)
        return
      }
      if (this.loadedParts) {
        for (const part in this.loadedParts) {
          this.removePartTemplates(part)
        }
      }
      if (this.hasAttribute('theme-bbs')) {
        this.parts = [
          {
            elem: '#theme-bbs-header',
            htmlFile: 'header'
          },
          {
            elem: '#theme-bbs-leftside',
            htmlFile: 'leftside'
          },
          {
            elem: '#theme-bbs-rightside',
            htmlFile: 'rightside'
          },
          {
            elem: '#theme-bbs-footer',
            htmlFile: 'footer'
          }
        ]
        this.parts.push({
          elem: '#theme-bbs-content-' + this.mountedMode,
          htmlFile: this.mountedMode
        })
      }
      const baseUrl =
        location.protocol +
        '//' +
        location.host +
        '/themes/' +
        this.theme +
        '/pack'
      if (this.parts) {
        this.partsHtml = {}
        this.partsLoadingStatus = {}
        this.templates = []
        this.htmlDrawn = {}
        this.waitingTemplates = []
        this.vueOnHtmlLoaded = false
        const initialData = {
          bbs: this.bbs
        }
        for (let i = 0; i < this.parts.length; i++) {
          const part = this.parts[i]
          this.loadPart(
            baseUrl,
            this.path,
            part.elem,
            part.htmlFile,
            initialData
          )
          if (part.originalHtmlFile) {
            part.htmlFile = part.originalHtmlFile
            delete part.originalHtmlFile
          }
        }
      }
    },
    checkPartsAndTemplatesLoaded() {
      if (!this.templates || this.templates.length === 0) {
        this.allTemplatesLoaded = true
      }
      if (
        !this.partsLoadingStatus ||
        Object.keys(this.partsLoadingStatus) === 0
      ) {
        this.allPartsLoaded = true
      }

      if (this.allPartsLoaded && this.allTemplatesLoaded) {
        if (!this.allPartsAndTemplatesLoadedEmitted) {
          this.$emit('all-parts-and-templates-loaded')
        }
        if (!this.isDefaultLayout) {
          this.$eventHub.$emit('content-loaded')
          this.$emit('content-loaded')
        }
        this.allPartsAndTemplatesLoadedEmitted = true
      }
    },
    setTemplateStatus(template, status) {
      if (!this.templates || this.templates.length === 0) {
        this.checkPartsAndTemplatesLoaded()
        return
      }
      template.status = status
      let allDrawn = true
      for (let i = 0; i < this.templates.length; i++) {
        if (this.templates[i].status !== 'drawn') {
          allDrawn = false
        }
      }
      if (allDrawn) {
        this.allTemplatesLoaded = true
        this.checkPartsAndTemplatesLoaded()
      }
    },
    setPartsLoadingStatus(part, status) {
      if (
        !this.partsLoadingStatus ||
        Object.keys(this.partsLoadingStatus) === 0
      ) {
        this.checkPartsAndTemplatesLoaded()
        return
      }
      this.partsLoadingStatus[part] = status
      let allLoaded = true
      let failed = false
      let loadingPartsExist = false
      const failedParts = []
      for (const part in this.partsLoadingStatus) {
        if (this.partsLoadingStatus[part] !== 'loaded') {
          allLoaded = false
        }
        if (this.partsLoadingStatus[part] === 'loading') {
          loadingPartsExist = true
        }
        if (!loadingPartsExist && this.partsLoadingStatus[part] === 'failed') {
          failed = true
          failedParts.push(part)
        }
      }
      if (allLoaded) {
        this.$emit('all-parts-loaded')
        if (!this.allPartsLoaded) {
          this.allPartsLoaded = true
          if (window.app && window.app.onAllPartsLoaded) {
            setTimeout(function() {
              window.app.onAllPartsLoaded()
            }, 500)
          }
        }
        this.checkPartsAndTemplatesLoaded()
      }
      if (failed) {
        this.$emit('parts-load-failed', failedParts)
      }
    },
    redraw() {
      if (this.partsHtml) {
        for (const part in this.partsHtml) {
          this.drawPart(this.partsHtml[part], part, true)
        }
      }
    },
    openLinkWithVibration(link, e, replace) {
      this.vibrate(e)
      this.openLink(link, e, replace)
    },
    isCouponUser() {
      if (!this.loggedInUser) {
        return true
      }
      const role = this.getMyMaxRole()
      if (!role) {
        return true
      }
      return role.role.startsWith('role_coupon_')
    },
    isCouponTicketUser() {
      if (!this.loggedInUser) {
        return true
      }
      const role = this.getMyMaxRole()
      if (!role) {
        return true
      }
      return role.role.startsWith('role_coupon_ticket')
    },
    openLinkOrBrowser(url, e) {
      if (!url) {
        return
      }
      if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
        this.openBrowser(url)
      } else if (url.indexOf('unistars:/') === 0) {
        this.openLink(url.substring('unistars:/'.length), e)
      } else {
        this.openLink(url, e)
      }
      if (e) {
        this.vibrate(e)
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
    },
    openLink(link, e, replace) {
      if (!link) {
        return
      }
      if (!this.$store) {
        this.$store = window._globalVueParams.$store
      }
      if (
        link === 'goods' ||
        link === 'category' ||
        link === 'login' ||
        link === 'logout' ||
        link === 'stipulation' ||
        link === 'registration' ||
        link === 'registration_stipulation' ||
        link === 'registration_complete' ||
        link === 'registration_detail' ||
        link === 'profile'
      ) {
        link = '/' + link
      }
      if (this.isCouponUser() && link === '/profile') {
        return
      }
      if (e) {
        this.vibrate(e)
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      if (link === '/') {
        if (replace) {
          this.$router.replace('/')
        } else {
          this.$router.push('/')
        }
        return
      }
      let router = this.$router
      if (!router) {
        router = window._globalVueParams.$router
      }
      if (router.totalRoutes) {
        if (this.loggedInUser && this.loggedInUser.menusForRequriedRoles) {
          let menuName
          if (link.indexOf('/') >= 0) {
            menuName = link.substring(link.lastIndexOf('/') + 1)
          } else {
            menuName = link
          }
          if (menuName && menuName.indexOf('?') >= 0) {
            menuName = menuName.substring(0, menuName.indexOf('?'))
          }
          if (menuName && menuName.indexOf('#') >= 0) {
            menuName = menuName.substring(0, menuName.indexOf('#'))
          }
          for (
            let k = 0;
            k < this.loggedInUser.menusForRequriedRoles.length;
            k++
          ) {
            const menu = this.loggedInUser.menusForRequriedRoles[k]
            if (
              menu.menu === menuName &&
              menu.requiredRole &&
              this.getDiffFromRoleGradeToMine(menu.requiredRole) > 0
            ) {
              if (window.showAlertModal) {
                window.showAlertModal(
                  this.$t('menu.alert.title.access_denied'),
                  this.$t('menu.alert.content.access_denied', {
                    menu: this.$t('menu.nm.homepage.' + menu.menu),
                    role: this.$t('role.nm.' + menu.requiredRole.role)
                  })
                )
              }
              return
            }
          }
        }
        for (let k = 0; k < router.totalRoutes.length; k++) {
          const route = router.totalRoutes[k]
          if (link.startsWith(route.path)) {
            if (replace) {
              router.replace(link)
            } else {
              router.push(link)
            }
            return
          }
        }
        console.error('Cannot find link : ' + link)
        window.open(link, '_blank')
      } else if (replace) {
        router.replace(link)
      } else {
        router.push(link)
      }
    },
    onVueOnHtmlLoaded() {
      this.vueOnHtmlLoaded = true
      if (this.waitingTemplates.length > 0) {
        this.$nextTick(() => {
          for (let i = this.waitingTemplates.length - 1; i >= 0; i--) {
            const template = this.waitingTemplates[i]
            this.drawTemplateWithData(template, template.data)
            this.waitingTemplates.splice(i, 1)
          }
          this.translateText()
          if (this.waitingTemplates.length === 0) {
            this.$eventHub.$emit('template-mounted', {
              componentId: this.getMainComponentId()
            })
          }
        })
      }
    },
    loadThemeScripts(callback) {
      window.loadScripts(
        ['https://code.jquery.com/jquery-3.3.1.min.js'],
        callback
      )
    },
    escapeTempHtml(responseText) {
      let escapedTempHtml = responseText
      escapedTempHtml = escapedTempHtml.replaceAll('<script', '<!-- #script')
      escapedTempHtml = escapedTempHtml.replaceAll('</script>', '</script# -->')
      return escapedTempHtml
    },
    unescapeTempHtml(escapedTempHtml) {
      let responseText = escapedTempHtml
      responseText = responseText.replaceAll('<!-- #script', '<script')
      responseText = responseText.replaceAll('</script# -->', '</script>')
      return responseText
    },
    drawPart(responseText, part, forceRedraw, templateInitialData) {
      if (!this.loadedParts) {
        this.loadedParts = {}
      }
      this.removePartTemplates(part)
      this.loadedParts[part] = {
        elem: part,
        templates: []
      }
      let escapedTempHtml = this.escapeTempHtml(
        this.translateHtml(responseText)
      )
      if ($(this.$el).find('.theme-temp').length === 0) {
        $(this.$el).append('<div class="theme-temp" />')
      }
      $(this.$el)
        .find('.theme-temp')
        .html(escapedTempHtml)
      $(this.$el)
        .find('.theme-temp')
        .find('.stipulation-agreement')
        .each(function() {
          $(this).attr(':value', 'stipulation.id')
          $(this).attr(':required', 'stipulation.esntlFlag==="Y"')
        })
      if ($(this.$el).find('.theme-temp [template]').length > 0) {
        const self = this
        $(this.$el)
          .find('.theme-temp [template]')
          .each(function() {
            self.addTemplate($(this), part, templateInitialData)
          })
        escapedTempHtml = $(this.$el)
          .find('.theme-temp')
          .html()

        $(this.$el)
          .find('.theme-temp')
          .html('')
        const hasVue = escapedTempHtml.indexOf('new Vue(') > 0
        this.escapedTempHtml = escapedTempHtml
        for (let i = 0; i < this.templates.length; i++) {
          if (this.templates[i].part === part) {
            this.templates[i].hasVue = hasVue
            self.loadTemplateData(
              this.templates[i],
              part,
              escapedTempHtml,
              this.templates[i].params,
              forceRedraw
            )
          }
        }
      } else {
        $(this.$el)
          .find('.theme-temp')
          .html('')
        const area = $(this.$el).find(part)
        area.html(this.unescapeTempHtml(escapedTempHtml))
        this.translateVue(part)
        this.translateText()
      }
    },
    addParam(url, key, value) {
      if (url.indexOf('?') >= 0) {
        url += '&'
      } else {
        url += '?'
      }
      url += key + '=' + value
      return url
    },
    loadTemplateData(
      template,
      part,
      escapedTempHtml,
      params,
      justDataLoad,
      showLoading
    ) {
      template.params = params
      template.originalScrollTop = $('html').scrollTop()
      if (template.name === 'menu-item') {
        if (!this.isMenuLoaded()) {
          setTimeout(() => {
            this.loadTemplateData(
              template,
              part,
              escapedTempHtml,
              params,
              justDataLoad
            )
          }, 50)
          return
        }
        this.setTemplateStatus(template, 'data-loaded')
        if (template.options && template.options.rootMenu) {
          template.data = this.getMenusByRootMenu(template.options.rootMenu)
        } else {
          let lcCode
          if (template.options && template.options.menuLocationCode) {
            lcCode = template.options.menuLocationCode
          } else {
            lcCode = 'menu_location.main'
          }
          template.data = this.getMenusByLocation(lcCode)
        }
        this.tryDrawTemplate(part, escapedTempHtml, justDataLoad)
      } else if (!template.url) {
        this.setTemplateStatus(template, 'data-loaded')
        template.data = [{}]
        this.tryDrawTemplate(part, escapedTempHtml, justDataLoad)
      } else {
        let url = template.url
        if (template.options && template.options.urlRefresh) {
          url = this.getUrlByTemplateNameAndOptions(
            template.name,
            template.options,
            template.apiUrl
          )
        }

        let foundSearchText = false
        let foundPageNo = false
        let foundLastId = false
        let mode = 'page'
        if (template.options && template.options.mode === 'more') {
          mode = 'more'
        }
        if (params) {
          for (const key in params) {
            if (key === 'searchText') {
              if (url.indexOf('searchText=') >= 0) {
                continue
              } else {
                foundSearchText = true
              }
            }
            if (key === 'pageNo') {
              if (mode === 'more' || !params.pageNo) {
                continue
              } else {
                foundPageNo = true
              }
            }
            if (key === 'lastId') {
              if (mode !== 'more' || !params.lastId) {
                continue
              } else {
                foundLastId = true
              }
            }
            url = this.addParam(url, key, params[key])
          }
        }
        if (!foundSearchText && this.searchParams) {
          const searchParam = this.searchParams[template.groupId]
          if (searchParam && searchParam.searchText) {
            url = this.addParam(url, 'searchText', searchParam.searchText)
          }
        }
        if (
          !foundPageNo &&
          (!template.options || template.options.topFlag !== 'Y') &&
          mode !== 'more' &&
          this.pageInfos
        ) {
          const pageInfo = this.pageInfos[template.groupId]
          if (pageInfo && pageInfo.pageNo) {
            url = this.addParam(url, 'pageNo', pageInfo.pageNo)
          }
        }
        if (!foundLastId && mode === 'more' && this.pageInfos) {
          const pageInfo = this.pageInfos[template.groupId]
          if (pageInfo && pageInfo.lastId) {
            url = this.addParam(url, 'lastId', pageInfo.lastId)
          }
        }
        this.setTemplateStatus(template, 'data-loading')
        this.$axios
          .$get(url, {
            no_loading: !showLoading // !justDataLoad
          })
          .then(response => {
            if (response.resultCode === 'success') {
              this.setTemplateStatus(template, 'data-loaded')
              if (template.name.endsWith('-item')) {
                let append = false
                if (template.options && template.options.mode === 'more') {
                  append = true
                }
                let loadedSize = 0
                let lastId = 0
                if (!template.data) {
                  template.data = []
                }
                const itemName = template.name.substring(
                  0,
                  template.name.length - 5
                )
                if (
                  response.data &&
                  response.data.list &&
                  response.data.list.length > 0
                ) {
                  if (append && template.data && params && params.lastId) {
                    template.data = template.data.concat(response.data.list)
                    template.loadedSize += response.data.loadedSize
                    loadedSize = template.loadedSize
                  } else {
                    template.data = response.data.list
                    template.loadedSize = response.data.loadedSize
                    loadedSize = template.loadedSize
                  }
                } else if (!append || !params || !params.lastId) {
                  template.data = []
                }
                if (template.data && template.data.length > 0) {
                  lastId = template.data[template.data.length - 1].id
                }
                template.lastId = lastId
                template.totalSize = response.data.totalSize
                template.size = response.data.size
                if (this.templates) {
                  for (let j = 0; j < this.templates.length; j++) {
                    const tmplat = this.templates[j]
                    if (
                      tmplat &&
                      (tmplat.name === 'more-items-control' ||
                        tmplat.name === 'load-on-scroll')
                    ) {
                      tmplat.lastId = template.lastId
                      tmplat.loadedSize = template.loadedSize
                      tmplat.totalSize = template.totalSize
                      tmplat.size = template.size
                    }
                  }
                }
                if (
                  !template.options ||
                  !template.options.topFlag ||
                  template.options.topFlag !== 'Y'
                ) {
                  const data = {
                    componentId: this.getMainComponentId(),
                    topFlag: 'N',
                    pageNo: response.data.pageNo,
                    totalSize: response.data.totalSize,
                    totalPageNo: response.data.totalPageNo,
                    loadedSize: loadedSize,
                    lastId: lastId,
                    options: template.options,
                    template: template,
                    groupId: template.groupId
                  }
                  data[itemName] = response.data.list
                  this.emitItemsLoaded(data)
                }
              } else {
                if (template.name.endsWith('-item-detail')) {
                  const itemName = template.name.substring(
                    0,
                    template.name.length - '-item-detail'.length
                  )
                  template[itemName] = response.data
                  template[itemName.toCamelCase()] = response.data
                }
                template.data = response.data
              }
              // 약관을 정의하지 않은 경우 바로 가입 페이지로 전환한다.
              if (template.name === 'stipulation-item') {
                template.data = response.data
                if (
                  template.options &&
                  template.options.stplatTyCode ===
                    'stipulation_type.registration' &&
                  (!template.data || template.data.length === 0)
                ) {
                  this.openLink('/registration')
                }
              }
              template.redraw = true
              this.tryDrawTemplate(part, escapedTempHtml, justDataLoad)
            } else if (response.message) {
              console.error(this.$t(response.message))
              this.$toast.error(this.$t(response.message))
            } else {
              console.error('Cannot load data.')
              this.$toast.error('Cannot load data.')
            }
          })
      }
    },
    emitItemsLoaded(data) {
      let allTemplatesDrawn = true
      for (let i = 0; i < this.templates.length; i++) {
        if (this.templates[i].status !== 'drawn') {
          allTemplatesDrawn = false
        }
      }
      if (!allTemplatesDrawn) {
        setTimeout(() => {
          this.emitItemsLoaded(data)
        }, 10)
        return
      }
      this.$eventHub.$emit('items-loaded', data)
    },
    tryDrawTemplate(part, escapedTempHtml, justDataLoad) {
      let dataLoadingCount = 0
      let originalScrollTop = 0
      for (let i = 0; i < this.templates.length; i++) {
        if (
          this.templates[i].status === 'ready' ||
          this.templates[i].status === 'data-loading'
        ) {
          dataLoadingCount++
        }

        if (this.templates[i].originalScrollTop > originalScrollTop) {
          originalScrollTop = this.templates[i].originalScrollTop
        }
      }
      if (!this.htmlDrawn[part]) {
        if (!justDataLoad) {
          $(this.$el)
            .find(part)
            .html(this.unescapeTempHtml(escapedTempHtml))
        }
        this.translateVue(part)
        this.htmlDrawn[part] = true
      }

      if (dataLoadingCount === 0) {
        this.drawTemplates()
        this.translateText(() => {
          if (originalScrollTop > 0) {
            $('html').scrollTop(originalScrollTop)
            setTimeout(() => {
              $('html').scrollTop(originalScrollTop)
            }, 100)
          }
        })
        if (window.onEvent['part-drawn']) {
          this.$nextTick(() => {
            window.onEvent['part-drawn'](part)
          })
        }
      }
    },
    removePartTemplates(part) {
      if (this.loadedParts && this.loadedParts[part]) {
        const loadedPart = this.loadedParts[part]
        for (let i = 0; i < loadedPart.templates.length; i++) {
          const template = loadedPart.templates[i]
          if (template.vm) {
            template.vm.$destroy()
            delete template.vm
          }
          for (let j = 0; j < this.templates.length; j++) {
            if (template.id === this.templates[j].id) {
              this.templates.splice(j, 1)
              break
            }
          }
        }
      }
    },
    loadPart(baseUrl, path, part, filename, templateInitialData) {
      if (part === '#theme-content') {
        return
      }
      if (!filename) {
        filename = part
      }
      if (!path.startsWith('/')) {
        path = '/' + path
      }
      if (!path.endsWith('/')) {
        path += '/'
      }
      if (!this.partsLoadingStatus[part]) {
        this.setPartsLoadingStatus(part, 'loading')

        let v = ''
        if (localStorage && localStorage.buildTime) {
          v = '?v=' + localStorage.buildTime
        }
        $.ajax(baseUrl + path + filename + '.html' + v).done(
          (responseText, status, xhr) => {
            if (
              status === 'success' &&
              responseText.indexOf('<!-- html part') >= 0
            ) {
              this.setPartsLoadingStatus(part, 'loaded')
              this.partsHtml[part] = responseText
              this.drawPart(
                this.partsHtml[part],
                part,
                false,
                templateInitialData
              )
            } else {
              this.setPartsLoadingStatus(part, 'failed')
              if (this.router) {
                this.router.push('/')
              }
            }
          }
        )
      } else if (this.partsLoadingStatus[part] === 'loaded') {
        this.setPartsLoadingStatus(part, 'loaded')
        this.drawPart(this.partsHtml[part], part, false, templateInitialData)
      }
    },
    translateText(cb) {
      const self = this
      if (Object.keys(self.messages).length === 0) {
        if (window._translateTimerId) {
          clearTimeout(window._translateTimerId)
          window._translateTimerId = undefined
        }
        window._translateTimerId = setTimeout(self.translateText, 50)
        return
      }
      $('t[code]').each(function() {
        if ($(this).attr('html') !== undefined) {
          $(this).html(self.$t($(this).attr('code')))
        } else {
          $(this).text(self.$t($(this).attr('code')))
        }
        $(this).attr('translated-code', $(this).attr('code'))
        $(this).removeAttr('code')
      })
      if (cb) {
        cb()
      }
    },
    translateHtml(html) {
      html = html.replaceAll(
        'href="pack/',
        'href="/themes/' + this.theme + '/pack/'
      )
      html = html.replaceAll(
        'href="./pack/',
        'href="/themes/' + this.theme + '/pack/'
      )
      html = html.replaceAll(
        'src="pack/',
        'src="/themes/' + this.theme + '/pack/'
      )
      html = html.replaceAll(
        'src="./pack/',
        'src="/themes/' + this.theme + '/pack/'
      )
      html = html.replaceAll(
        'url(pack/',
        'url(/themes/' + this.theme + '/pack/'
      )
      html = html.replaceAll(
        "url('pack/",
        "url('/themes/" + this.theme + '/pack/'
      )
      html = html.replaceAll(
        'url(./pack/',
        'url(/themes/' + this.theme + '/pack/'
      )
      html = html.replaceAll("'pack/", "'/themes/" + this.theme + '/pack/')
      html = html.replaceAll("'./pack/", "'/themes/" + this.theme + '/pack/')
      html = html.replaceAll('__SITE_ID__', process.env.siteId)
      html = html.replaceAll('__THEME__', this.configs.theme)
      return html
    },
    translateVue(part) {
      const self = this
      $(this.$el)
        .find(part + ' [sample]')
        .each(function() {
          $(this).remove()
        })
      $(this.$el)
        .find('a[href]')
        .each(function() {
          if (!$(this).attr('no-layout')) {
            let href = $(this).attr('href')
            const prefix = '/themes/' + self.theme + '/pack/'
            if (href.startsWith(prefix)) {
              href = href.substring(prefix.length)
              if (href.endsWith('.html')) {
                href = href.substring(0, href.length - 5)
              }
              $(this).attr('href', '#' + href)
            }
          }
        })
      $(this.$el)
        .find('[href="#home"],[href="/#home"],[href="/"]')
        .each(function() {
          $(this).attr('v-on:click', 'goHome()')
          $(this).removeAttr('href')
          const html = $(this).get(0).outerHTML
          const router = self.$router
          const HomeLink = Vue.extend({
            data: function() {
              return {
                router: router
              }
            },
            methods: {
              goHome() {
                this.router.push('/')
              }
            },
            template: html
          })
          new HomeLink().$mount($(this).get(0))
        })
      $(this.$el)
        .find('[href]')
        .each(function() {
          if (
            $(this)
              .attr('href')
              .indexOf('unistars://') === 0
          ) {
            $(this).attr(
              'v-on:click',
              "openLink('" +
                $(this)
                  .attr('href')
                  .substring('unistars:/'.length) +
                "')"
            )
            $(this).removeAttr('href')
            $(this).removeAttr('target')
          }
        })
    },
    addTemplate(templateObj, part, templateInitialData) {
      if (!templateObj.attr('template')) {
        throw new Error('template attribute has no value!')
      }
      if (!window._templateId) {
        window._templateId = 0
      }
      window._templateId++
      templateObj.attr('template-id', window._templateId)
      templateObj.attr('rendered', 'true')
      const name = templateObj.attr('template')
      templateObj.attr('template-name', name)
      templateObj.removeAttr('template')
      let options
      if (templateObj.attr('options')) {
        options = JSON.parse(templateObj.attr('options'))
      }
      let groupId
      if (templateObj.attr('group-id')) {
        groupId = templateObj.attr('group-id')
      }
      let apiUrl
      if (templateObj.attr('api-url')) {
        apiUrl = templateObj.attr('api-url')
      }
      const html = templateObj.get(0).outerHTML
      const template = {
        status: 'ready', // ready -> data-loading -> data-loaded -> drawn
        part: part,
        html: html,
        hasVue: html.indexOf('new Vue(') >= 0,
        name: name,
        options: options,
        apiUrl: apiUrl,
        id: window._templateId,
        groupId: groupId,
        redraw: true,
        initialData: templateInitialData,
        url: this.getUrlByTemplateNameAndOptions(name, options, apiUrl)
      }
      templateObj.replaceWith(
        '<!-- template-rendering-area template-id="' + template.id + '" -->'
      )
      this.loadedParts[part].templates.push(template)
      this.templates.push(template)
      return template
    },
    getUrlByTemplateNameAndOptions(name, options, apiUrl) {
      let baseUrl = ''
      let params = ''
      if (this.$route.query.id) {
        if (!params) {
          params = '?'
        } else {
          params += '&'
        }
        params += 'id=' + this.$route.query.id
      }
      if (this.$route.params.alias) {
        if (!params) {
          params = '?'
        } else {
          params += '&'
        }
        params += 'alias=' + this.$route.params.alias
      }
      if (name === 'player-control') {
        if (!params) {
          params = '?'
        } else {
          params += '&'
        }
        params += 'id=' + this.$route.query.goodsId
        params += '&play=true'
      }
      let foundMenu = false
      let foundSize = false
      for (const optionKey in options) {
        if (optionKey === 'passQueryParams') {
          continue
        }
        if (!params) {
          params = '?'
        } else {
          params += '&'
        }
        if (optionKey === 'menu') {
          foundMenu = true
        }
        if (optionKey === 'size') {
          foundSize = true
        }
        params += optionKey + '=' + options[optionKey]
      }
      if (!foundMenu) {
        if (!params) {
          params = '?'
        } else {
          params += '&'
        }
        let menuAlias = this.$router.currentRoute.fullPath
        if (menuAlias.indexOf('?') >= 0) {
          menuAlias = menuAlias.substring(0, menuAlias.indexOf('?'))
        }
        params += 'menu=' + encodeURIComponent(menuAlias)
      }
      if (name.endsWith('-item')) {
        if (!foundSize) {
          params += '&size=15'
        }
        if (options && options.mode && options.mode === 'more' && this.lastId) {
          params += '&lastId=' + this.lastId
        }
        if (options && options.search) {
          params += '&searchText=' + this.$route.query.q
        }
        const itemName = name.substring(0, name.length - 5)
        baseUrl = itemName + '/public/' + itemName
      }
      if (name === 'update-item-control') {
        params += '&update=true'
      }
      if (window._apiUrls[name]) {
        baseUrl = window._apiUrls[name]
      }
      if (
        options &&
        options.passQueryParams &&
        options.passQueryParams.length
      ) {
        if (this.$route.query) {
          for (const key in this.$route.query) {
            if (options.passQueryParams.indexOf(key) >= 0) {
              const queryValue = this.$route.query[key]
              if (!queryValue || queryValue === 'undefined') {
                continue
              }
              if (!params) {
                params += '?'
              } else {
                params += '&'
              }
              params += key + '='
              params += queryValue
            }
          }
        }
      }
      if (apiUrl) {
        baseUrl = apiUrl
      }
      if (baseUrl) {
        return baseUrl + params
      }
      return ''
    },
    drawTemplateWithNameAndData(templateName, data, redraw) {
      if (!this.templates || this.templates.length === 0) {
        return
      }
      for (let i = 0; i < this.templates.length; i++) {
        if (this.templates[i].name === templateName) {
          this.templates[i].redraw = redraw
          this.drawTemplateWithData(this.templates[i], data)
        }
      }
    },
    selectCommentNode(container, textContent) {
      let commentNode
      for (let i = 0; i < container.length; i++) {
        const childNode = $(container[i]).get(0)
        if (childNode.nodeType === 1) {
          commentNode = this.selectCommentNode(
            childNode.childNodes,
            textContent
          )
        } else if (
          childNode.nodeType === 8 &&
          childNode.textContent === textContent
        ) {
          return $(childNode)
        }
        if (commentNode) {
          break
        }
      }
      return commentNode
    },
    drawTemplateWithData(template, data) {
      if (!template.redraw) {
        return
      }

      template.data = data
      $('[template-id=' + template.id + '][rendered=true]').each(function() {
        $(this).attr('remove-this-element', 'true')
      })
      if (!Array.isArray(data)) {
        data = [data]
      }
      for (let j = 0; j < data.length; j++) {
        if (template.name === 'menu-item') {
          if (!data[j] || data[j].displayMainFlag === 'N') {
            continue
          }
          const link = data[j].link
          if (this.loggedInUser) {
            if (link === 'login' || link === '/login') {
              continue
            }
            if (link === 'registration' || link === '/registration') {
              continue
            }
          } else {
            if (link === 'logout' || link === '/logout') {
              continue
            }
            if (link === 'profile' || link === '/profile') {
              continue
            }
            if (
              link === 'registration_stipulation' ||
              link === '/registration_stipulation'
            ) {
              continue
            }
            if (
              link === 'registration_complete' ||
              link === '/registration_complete'
            ) {
              continue
            }
            if (
              link === 'registration_detail' ||
              link === '/registration_detail'
            ) {
              continue
            }
          }
        }
        if (template.vm) {
          template.vm.$destroy()
          delete template.vm
        }
        const templateRenderingArea = this.selectCommentNode(
          [$(this.$el).get(0)],
          ' template-rendering-area template-id="' + template.id + '" '
        )

        $(
          '<div template-id="' + template.id + '" data-no="' + j + '" />'
        ).insertBefore(templateRenderingArea)
        const NewTemplate = this.createVueTemplateComponent(template, data, j)
        template.vm = new NewTemplate().$mount(
          $(this.$el)
            .find('div[template-id=' + template.id + '][data-no=' + j + ']')
            .get(0)
        )
        if (!template.vm.$store) {
          template.vm.$store = window._globalVueParams.$store
        }
      }
      this.setTemplateStatus(template, 'drawn')
      template.redraw = false
      this.$nextTick(() => {
        if (window.onEvent && window.onEvent[template.name + '-data-loaded']) {
          window.onEvent[template.name + '-data-loaded'](template)
        }
        $('[remove-this-element=true]').each(function() {
          $(this).remove()
        })
      })
    },
    drawTemplates() {
      const templates = this.templates
      if (!templates || templates.length === 0) {
        return
      }
      for (let i = 0; i < templates.length; i++) {
        const template = templates[i]
        if (template.status === 'data-loaded') {
          if (this.vueOnHtmlLoaded || !template.hasVue) {
            this.drawTemplateWithData(template, template.data)
          } else {
            this.waitingTemplates.push(template)
          }
        }
      }
      if (this.waitingTemplates.length === 0) {
        this.$eventHub.$emit('template-mounted', {
          componentId: this.getMainComponentId()
        })
      }
    }
  }
})
